module.exports = __webpack_public_path__ + "img/dc.a371d785.svg";